export const environment = {
  api: {
    strapiBaseUrl: 'https://ebf-cms-dot-ebf-championships.ew.r.appspot.com',
    baseUrl: 'https://ebf-championships-backend-dot-ebf-championships.ew.r.appspot.com/api/v1',
    ws: 'wss://ebf-championships-backend-dot-ebf-championships.ew.r.appspot.com/events',
  },
  mapApiKey: 'AIzaSyDpXqBs78bX6GLDRRqgWMhgdu0RqPJ0Ask',
  currentChampionshipRedirectEnabled: true,
};
